import { render, staticRenderFns } from "./ShareLinkForm.vue?vue&type=template&id=c12ab274&scoped=true"
import script from "./ShareLinkForm.vue?vue&type=script&lang=js"
export * from "./ShareLinkForm.vue?vue&type=script&lang=js"
import style0 from "./ShareLinkForm.vue?vue&type=style&index=0&id=c12ab274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12ab274",
  null
  
)

export default component.exports